import React from 'react';
import { Store } from 'redux';
import { History } from 'history';
import { Provider as ReduxProvider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import PlayerLayoutRoute from './player-layout-route';

type DefaultRootProps = {
  store: Store;
  history: History;
};

const DefaultRoot = (props: DefaultRootProps) => {
  return (
    <ReduxProvider store={props.store}>
      <ConnectedRouter history={props.history}>
        <Switch>
          <Route
            path={[
              '/live/embed/:experienceId',
              '/:city/place/:placeId/action-video/:type',
              '/:city/experience/:experienceId',
            ]}
            exact
            component={PlayerLayoutRoute}
          />

          <Route component={() => null} />
        </Switch>
      </ConnectedRouter>
    </ReduxProvider>
  );
};

export default DefaultRoot;
